import { render } from "./CoutureMetaverse3dView.vue?vue&type=template&id=7dfb4204&scoped=true"
import script from "./CoutureMetaverse3dView.vue?vue&type=script&lang=js"
export * from "./CoutureMetaverse3dView.vue?vue&type=script&lang=js"

import "./CoutureMetaverse3dView.vue?vue&type=style&index=0&id=7dfb4204&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfb4204"]])

export default __exports__